
import { Phone, Mail, MapPin } from "lucide-react";

export const ContactInfoCard = () => {
  return (
    <div className="bg-white p-8 rounded-lg shadow-lg border border-[#e0f2fe]">
      <h3 className="text-2xl font-medium mb-6 text-[#0c4a6e]">Información de contacto</h3>
      
      <div className="space-y-6">
        <div className="flex items-start">
          <div className="bg-[#e0f2fe] p-3 rounded-lg mr-4">
            <Phone className="h-6 w-6 text-[#0284c7]" />
          </div>
          <div>
            <h4 className="font-medium text-[#0c4a6e]">Teléfono</h4>
            <p className="text-[#64748b]">Gladys Velasquez</p>
            <a href="tel:+17865695142" className="text-[#64748b] hover:text-[#0284c7] transition-colors">(888) 370-8454</a>
          </div>
        </div>
        
        <div className="flex items-start">
          <div className="bg-[#e0f2fe] p-3 rounded-lg mr-4">
            <Mail className="h-6 w-6 text-[#0284c7]" />
          </div>
          <div>
            <h4 className="font-medium text-[#0c4a6e]">Correo electrónico</h4>
            <a 
              href="mailto:info@gavinsurance.com"
              className="text-[#64748b] hover:text-[#0284c7] transition-colors"
            >
              info@gavinsurance.com
            </a>
          </div>
        </div>
        
        <div className="flex items-start">
          <div className="bg-[#e0f2fe] p-3 rounded-lg mr-4">
            <MapPin className="h-6 w-6 text-[#0284c7]" />
          </div>
          <div>
            <h4 className="font-medium text-[#0c4a6e]">Dirección</h4>
            <p className="text-[#64748b]">7500 NW 25 ST #237</p>
            <p className="text-[#64748b]">Doral, FL 33122</p>
          </div>
        </div>
      </div>
    </div>
  );
};
